import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " FAMILY MONTHLY EXPENSES", -1)
const _hoisted_3 = { class: "tw-px-4" }
const _hoisted_4 = {
  key: 0,
  class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]"
}
const _hoisted_5 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_6 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = {
  key: 1,
  class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "tw-even:bg-gray-50 tw-odd:bg-white" }, [
    /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " NO MLO'S TABLES FOUND ")
  ])
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "tw-flex tw-justify-evenly tw-items-center tw-mt-[35px] tw-mb-[35px] tw-w-full tw-gap-[140px]" }
const _hoisted_12 = { class: "tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "tw-items-center tw-gap-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " TOTAL EXPENSES $: ", -1)
const _hoisted_16 = { class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3 d-flex align-items-center justify-contetn-center" }

import { ref, toRefs, watch } from 'vue';
import { currencyFormat } from '@/composables/filters';

export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyMonthlyExpenses',
  props: {
  selectedMLO: {
    type: Object,
    default: null
  },
  familyHousingExpenses: {
    type: Object,
    default: {}
  },
  totalFamilyHousingExpenses: {
    type: Object,
    default: 0
  }
},
  setup(__props) {

const props = __props;


const { selectedMLO, familyHousingExpenses, totalFamilyHousingExpenses }: any = toRefs(props)

watch(
  () => selectedMLO.value?.familyHousingExpenses,
  (newExpenses) => {
    if (newExpenses) {  // Check if newExpenses exists
      newExpenses.forEach(expense => {
        const expenseKey = expense.expense.replace(/\s+/g, '_');
        if (!(expenseKey in familyHousingExpenses.value)) {
          familyHousingExpenses.value[expenseKey] = 0;
        }
      });
    }
  },
  { immediate: true }
);

// Watch all dynamic properties for changes and calculate total
watch(familyHousingExpenses.value, (newValues) => {
  totalFamilyHousingExpenses.value.total = Object.values(newValues).reduce((sum, value) => sum + (value || 0), 0);
}, { deep: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_unref(selectedMLO) !== null)
        ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedMLO).familyHousingExpenses, (expense, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "tw-even:bg-gray-50 tw-odd:bg-white",
                  key: index
                }, [
                  _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("span", null, _toDisplayString(expense.expense), 1)
                  ]),
                  _createElementVNode("td", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_unref(familyHousingExpenses)[expense.expense.replace(/\s+/g, '_')]) = $event),
                      type: "number"
                    }, null, 8, _hoisted_7), [
                      [_vModelText, _unref(familyHousingExpenses)[expense.expense.replace(/\s+/g, '_')]]
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(selectedMLO) == null)
        ? (_openBlock(), _createElementBlock("table", _hoisted_8, _hoisted_10))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_unref(selectedMLO) !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(currencyFormat)(_unref(totalFamilyHousingExpenses).total)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})